module.exports = __webpack_public_path__ + "img/search.c03eb316.svg";